/* global G */
import { get, set } from 'lib/sequence/component/state/value'
import { getFirstItem } from 'lib/util'
import filterRef from './ref'

/**
 * Sets the assignee filter according to the selected value.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @returns {function(*, {filter?: {}}=, ...[*]): Promise<[undefined,{filter: {}},...*[]]>}
 */
export default module => async (children, { filter = {} } = {}, ...args) => {
  const model = module[G.MODEL]
  const { assignee } = children

  const accumulatedFilter = filter
  const selectedAssignee = get(assignee)

  assignee[G.STATE][G.REF] = !!accumulatedFilter.team && 'team'
  model[G.CHILDREN].team[G.STATE][G.REF] = accumulatedFilter.team

  !get(assignee) && set(assignee, [])

  const noAssignee = getFirstItem(selectedAssignee)?.key === 'none'
  noAssignee
    ? accumulatedFilter.refexists = '!assignee'
    : accumulatedFilter.assignee = filterRef(module, selectedAssignee)

  return [children, { filter: accumulatedFilter }, ...args]
}
